import React, { Component } from "react";
import NavDropdown from "react-bootstrap/NavDropdown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisV } from "@fortawesome/free-solid-svg-icons";
import Disconnect from '../Sites/Disconnect';
import Cookies from "js-cookie";
import "./topnav.css";

export default class UserDropdown extends Component {
  constructor(props) {
    super(props);
    this.radioMenuOptions = ["Decimal Radio Id", "Hex Radio Id"];
    this.batteryMenuOptions = ["Battery Voltage", "Battery Icons"];

    this.state = {
      radioMenu: this.props.radioFormat ? this.props.radioFormat(0) : 0,
      batteryMenu: this.props.batteryFormat ? this.props.batteryFormat() : 0,
      //siteMenu: this.props.siteFormat && this.props.siteFormat > 0 ? this.props.siteFormat : 0,
    };
    this.menuLogout = this.menuLogout.bind(this);
    this.menuRadioFormat = this.menuRadioFormat.bind(this);
    this.menuBatteryFormat = this.menuBatteryFormat.bind(this);
    this.menuUserList = this.menuUserList.bind(this);
    this.menuSitesEdit = this.menuSitesEdit.bind(this);
    this.menuAccount = this.menuAccount.bind(this);
    this.menuGrantEdit = this.menuGrantEdit.bind(this)
  }

  menuLogout() {
    if (!this.props.loginExpired()) {
      Disconnect(this.props)
    }
    this.props.userHasAuthenticated(false);
    window.location.replace("/login");
  }

  menuUserList() {
    this.props.history.push("/user/edit");
  }

  menuBilling() {
    window.location.replace("/billing");
  }

  menuAccount() {
    window.location.replace("/account");
  }

  menuGrantEdit() {
    this.props.history.push("/grants");
  }
  menuFavorites = () => {
    this.props.history.push('/favorites')
  }
  menuSitesEdit() {
    this.props.history.push("/sites");
  }
  menuRadioFormat() {
    const format = this.props.radioFormat ? this.props.radioFormat(1) : 0;
    this.setState({ radioMenu: format });
    if (this.props.parentUpdate) this.props.parentUpdate();
  }

  menuBatteryFormat() {
    const format = this.state.batteryMenu ? 0 : 1;
    this.setState({ batteryMenu: format });
    this.props.batteryFormat && this.props.batteryFormat(format);
  }
  menuResources() {
    window.open("https://www.tehamawireless.com/support-and-training", "_blank");
  }

  // Dropmenu handle function
  /* This was added to control the dropmenu state from other components, mainly for the tour process */
  handleToggle = (status) => {
    //if (!this.props.tour) {
      this.props.updateDropmenuState(status);
    //}
  };

  // Launch tour handle function
  handleLaunchTour = () => {
    Cookies.remove("tour-" + this.props.siteLocation);
    this.props.launchTourStatus(true);
  };

  render() {
    return (
      <NavDropdown align="end" title={<FontAwesomeIcon icon={faEllipsisV} size="lg" />}
        onToggle={this.handleToggle} show={this.props.dropMenu}>
        <div className="tour-dropdown">
          <NavDropdown.Item href="/login" onClick={() => this.menuLogout()}>
            Logout
          </NavDropdown.Item>
          <NavDropdown.Divider />
          <div className="tour-menu-group1">
            <NavDropdown.Item
              className="tour-myaccount"
              href="#"
              onClick={() => this.menuAccount()}
            >
              My Account
            </NavDropdown.Item>
            <NavDropdown.Item
              className="tour-billing"
              href="#"
              onClick={() => this.menuBilling()}
            >
              Billing
            </NavDropdown.Item>
            <NavDropdown.Item
              className="tour-sites"
              onClick={this.menuSitesEdit}
            >
              Sites
            </NavDropdown.Item>
            <NavDropdown.Item onClick={this.menuGrantEdit} href="#">
              Grants
            </NavDropdown.Item>
            <NavDropdown.Item onClick={this.menuFavorites} href="#">
              Favorites
            </NavDropdown.Item>

            <NavDropdown.Item className="tour-users" href="#"
              onClick={() => this.menuUserList()}
            >
              Users
            </NavDropdown.Item>
          </div>
          <NavDropdown.Divider />
          <div className="tour-menu-group2">
            <NavDropdown.Item
              className="tour-battery"
              onClick={() => this.menuBatteryFormat()}
            >
              {this.batteryMenuOptions[this.state.batteryMenu]}
            </NavDropdown.Item>
            <NavDropdown.Item
              className="tour-decimal"
              onClick={() => this.menuRadioFormat()}
            >
              {this.radioMenuOptions[this.state.radioMenu]}
            </NavDropdown.Item>
            <NavDropdown.Divider />
            <NavDropdown.Item
              className="tour-other"
              onClick={() => this.menuResources()}
            >
              Other Resources
            </NavDropdown.Item>
          </div>
          <NavDropdown.Item
            className="tour-other"
            onClick={() => this.handleLaunchTour()}
          >
            Launch Tour
          </NavDropdown.Item>
        </div>
      </NavDropdown>
    );
  }
}
//  <NavDropdown.Item href="#" onClick={()=>this.menuGrantRequest()}>Request Grants</NavDropdown.Item>
//  <NavDropdown.Item href="#" onClick={()=>this.menuSiteEdit()}>Claim Sites</NavDropdown.Item>
/*  menuGrantRequest() {
    this.props.history.push("/requests")
  }
  menuSiteEdit() {
    this.props.history.push("/claim")
  }
*/
/*            <NavDropdown.Item
              className="tour-grants"
              href="#"
              onClick={() => this.menuGrantEdit()}
            >
              Grants
            </NavDropdown.Item>

*/